import { render, staticRenderFns } from "./DatesOfMonthBarChartYear.vue?vue&type=template&id=04fceced&scoped=true"
import script from "./DatesOfMonthBarChartYear.vue?vue&type=script&lang=js"
export * from "./DatesOfMonthBarChartYear.vue?vue&type=script&lang=js"
import style0 from "./DatesOfMonthBarChartYear.vue?vue&type=style&index=0&id=04fceced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fceced",
  null
  
)

export default component.exports